export const LOYALTY_TEXT =
  'условиями программы "СберСпасибо"';
export const BONUS_PROGRAM_TEXT = 'условиями программы';
